import { EmbeddedWebConsoleAppEventHandlers } from './embedded-web-console-app-event-handlers';
import { WebConsoleAppInterface } from './web-console-container.interface';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { lensEventRoutes } from 'common/common/constants/lens';

export class LensEventHandlers implements EmbeddedWebConsoleAppEventHandlers {
  private _boundNavigationChangeRequest: Function = null;
  private _boundWorkflowEnded: Function = null;
  private _boundClientInfoUpdated: Function = null;

  constructor(private _embeddedApp: WebConsoleAppInterface, private RxEmitter: RxEmitter) {
  }

  public registerEvents() {
    this._boundNavigationChangeRequest = this._handleLensNavigationChangeRequest.bind(this);
    this._boundWorkflowEnded = this._handleLensWorkflowEnded.bind(this);
    this._boundClientInfoUpdated = this._handleLensClientInfoUpdated.bind(this);

    this._embeddedApp.ports.navigationChangeRequest.subscribe(this._boundNavigationChangeRequest);
    this._embeddedApp.ports.workflowEnded.subscribe(this._boundWorkflowEnded);
    this._embeddedApp.ports.clientInfoUpdated.subscribe(this._boundClientInfoUpdated);
  }

  public unregisterEvents() {
    this._embeddedApp.ports.navigationChangeRequest.unsubscribe(this._boundNavigationChangeRequest);
    this._embeddedApp.ports.workflowEnded.unsubscribe(this._boundWorkflowEnded);
    this._embeddedApp.ports.clientInfoUpdated.unsubscribe(this._boundClientInfoUpdated);
  }

  public onDestroyEvents() {
    return;
  }

  private _handleLensNavigationChangeRequest(request: any) {
    this.RxEmitter.send(lensEventRoutes.navigationChanged, request);
  }

  private _handleLensWorkflowEnded(reason: string) {
    this.RxEmitter.send(lensEventRoutes.sessionEnded, reason);
  }

  private _handleLensClientInfoUpdated(changes: any) {
    this.RxEmitter.send(lensEventRoutes.visitorInfoChanged, changes);
  }
}
